import { useState } from "react";
import { Breadcrumb, Button, FloatingLabel, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import LoadingComponent from "../../../widgets/LoadingComponent";
import { FaPlus, FaSearch, FaTrash } from "react-icons/fa";
import { getData } from "../../../api/ApiRest";
import { formatDateddMMMyyyy } from "../../../widgets/DateTime";
import auditoriaSet from "../../../widgets/Auditoria";

function Novedad() {
    const [loading, setLoading] = useState(false);
    const [dataBuscar, setDataBuscar] = useState({
        Desde: new Date().toISOString().split("T")[0],
        Hasta: new Date().toISOString().split("T")[0]
    });

    const [novedades, setNovedades] = useState([]);

    const navigate = useNavigate();

    const handleNavigate = () => {
        navigate('/Home/NovedadesCrud/:id');
    }

    const buscarDocumentos = (event) => {
        event.preventDefault();
        setLoading(true);

        getData('api/Configuracion/Novedad/getIndexNovedad', {
            desde: dataBuscar.Desde,
            hasta: dataBuscar.Hasta
        }).then(response => {
            setNovedades(response.novedades)

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        });
    }

    const tipo = (tipo) => {
        if (tipo === "A")
            return "Actualización";
        else if (tipo === "M")
            return "Mejoras";
        else if (tipo === "N")
            return "Noticias";
    }

    const eliminarNovedad = (novedadid) => {
        setLoading(true);

        let objeto = novedades.filter(x => x.novedadid === novedadid)[0];

        getData('api/Configuracion/Novedad/eliminarNovedad', {
            id: novedadid
        }).then(response => {
            alert('Novedad eliminada con éxito');
            setNovedades(prev => prev.filter(item => item.novedadid !== novedadid));

            auditoriaSet(objeto, {}, 'E', 'Novedad', '', 'EliminaNov');

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        });
    }

    return <div className='BodyComponent'>
        <Breadcrumb>
            <Breadcrumb.Item style={{ fontSize: 14 }} >Home</Breadcrumb.Item>
            <Breadcrumb.Item style={{ fontSize: 14 }} active={true}>Novedades</Breadcrumb.Item>
        </Breadcrumb>

        <div className="d-flex gap-1">
            <Button type='button' variant='success' title='Nueva novedad' size='sm'
                onClick={() => handleNavigate()}>
                <FaPlus size={'0.8rem'} />
            </Button>
        </div>

        <br />

        <Form onSubmit={buscarDocumentos}>

            <div className='row'>

                <div className='col-md-3'>
                    <FloatingLabel
                        controlId="FechaDesde"
                        label="Fecha desde"
                        className="form-floating-sm mb-3"
                    >
                        <Form.Control
                            size='sm'
                            type="date"
                            autoComplete='off'
                            required={true}
                            value={dataBuscar.Desde}
                            onChange={value => {
                                setDataBuscar({
                                    ...dataBuscar,
                                    Desde: value.target.value
                                })
                            }}
                            className="input-fecha-sm"
                        />
                    </FloatingLabel>
                </div>

                <div className='col-md-3'>
                    <FloatingLabel
                        controlId="FechaHasta"
                        label="Fecha hasta"
                        className="form-floating-sm mb-3"
                    >
                        <Form.Control
                            size='sm'
                            type="date"
                            autoComplete='off'
                            required={true}
                            value={dataBuscar.Hasta}
                            onChange={value => {
                                setDataBuscar({ ...dataBuscar, Hasta: value.target.value })
                            }}
                            className="input-fecha-sm"
                        />
                    </FloatingLabel>
                </div>

                <div className='col-md-1'>
                    <Button variant='primary' type='submit' size='sm'>
                        <FaSearch size={'0.8rem'} />
                    </Button>
                </div>

            </div>

        </Form>

        {<LoadingComponent Loading={loading} />}

        <hr />

        <div className='table-responsive mt-3'>
            <table className='table table-borderless table-hover'>
                <thead>
                    <tr>
                        <th className='estilo-encabezado' style={{ fontSize: 12 }}>

                        </th>
                        <th className='estilo-encabezado' style={{ fontSize: 12 }}>
                            #
                        </th>
                        <th className='estilo-encabezado' style={{ fontSize: 12 }}>
                            Titulo
                        </th>
                        <th className='estilo-encabezado' style={{ fontSize: 12 }}>
                            Fecha
                        </th>
                        <th className='estilo-encabezado' style={{ fontSize: 12 }}>
                            Tipo
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {novedades.map((item, i) => (
                        <tr key={i}>
                            <td style={{ textAlign: 'center' }}>
                                <Button variant="danger" type="button" title="Eliminar novedad" size="sm" onClick={() => eliminarNovedad(item.novedadid)}>
                                    <FaTrash size={'0.8rem'} />
                                </Button>
                            </td>
                            <td className="text-center" style={{ fontSize: 12 }}>
                                {i + 1}
                            </td>
                            <td className="text-center" style={{ fontSize: 12 }}>
                                {item.titulo}
                            </td>
                            <td className="text-center" style={{ fontSize: 12 }}>
                                {formatDateddMMMyyyy(item.fechaAct)}
                            </td>
                            <td className="text-center" style={{ fontSize: 12 }}>
                                {tipo(item.tipo)}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>

    </div>
}

export default Novedad;